import React from 'react';
import { TextField, Typography } from '@mui/material';

const Estados = ({ obraSelecionada, control }) => {
  return (
    <>
      <div style={{ width: '39%' }}>
        <h4
          style={{ color: '#E21450' }}
          className='text-underline-title-drawer '
        >
          Estados
        </h4>
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
          <div style={{ width: '49%' }}>
            <Typography style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              Projeto
            </Typography>

            <TextField
              size='small'
              value={
                (obraSelecionada && obraSelecionada.estadosProjetosDescricao) ||
                ' --/--/---- '
              }
              variant='outlined'
              disabled
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ width: '49%' }}>
            <Typography style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              Subprojeto{' '}
            </Typography>
            <TextField
              size='small'
              value={
                (obraSelecionada &&
                  obraSelecionada.estadosSubProjetosDescricao) ||
                ' --/--/---- '
              }
              variant='outlined'
              disabled
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Estados;
